import { EventNames } from '../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipSheetEventIds } from '../../../../analytics/plansEvents'
import { PlansErrorStateLayout } from '../../../../ui/PlansErrorStateLayout'

type SipPlanRecommendationSheetErrorStateProps = {
  onRetry: () => void
  analyticsScreen?: string
}

export function SipPlanRecommendationSheetErrorState({
  onRetry,
  analyticsScreen = PlansScreen.SipYourPlanRecommendation
}: SipPlanRecommendationSheetErrorStateProps) {
  return (
    <PlansErrorStateLayout>
      <div className="flex flex-col items-center gap-5">
        <div className="text-[22px] font-[500] leading-[130%] text-[#232323]">Something went wrong</div>
        <div className="text-center text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
          We couldn&apos;t load this SIP recommendation right now.
        </div>
        <div
          className="mt-1 inline-flex !h-10 w-[120px] cursor-pointer items-center justify-center rounded-xl bg-[#232323] text-[14px] font-[500] text-white"
          onClick={() => {
            trackEvent({
              eventName: EventNames.ButtonTap,
              payload: {
                ScreenName: analyticsScreen,
                eventId: PlansSipSheetEventIds.Retry,
                buttonLabel: 'Retry'
              }
            })
            onRetry()
          }}
        >
          Retry
        </div>
      </div>
    </PlansErrorStateLayout>
  )
}
